// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__u5gg+","footerInfo":"Footer_footerInfo__yOa4q","footerSocial":"Footer_footerSocial__qtm+J","link":"Footer_link__c5ir1","copy":"Footer_copy__Ws--o"};